import React from 'react';

export default function Page({ className = '', children }) {
  return (
    <div className={`page-shell px-3 px-md-4 py-3 ${className}`.trim()}>
      {children}
    </div>
  );
}


